import React from "react";
import styled from "styled-components";
import { MdDashboard } from "react-icons/md";
import { BsBoxFill } from "react-icons/bs";
import { FaUserCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
import AiFillHome from "../Images/lion.png";
import TGH from "../Images/FullLogo_NoBuffer__4_-removebg-preview.png";
import { PiShoppingCartFill } from "react-icons/pi";
import { useSelector } from "react-redux";
// import { cartProductSelector } from "../../Api/cartSlice";
import ScrollToTop from "react-scroll-to-top";
import { FaCar } from "react-icons/fa6";
import Hotel from "../Images/resorts.png";
import Courier from "../Images/delivery.png";
import Tours from "../Images/Tours.png";
import Cabs from "../Images/transport.png"
import Cry from '../Images/profileImage.png' 
import { TbLeaf } from "react-icons/tb";
import { FaCarSide } from "react-icons/fa";
import { FaBuilding } from "react-icons/fa";
import { MdTravelExplore } from "react-icons/md"; 


function Footer() {
  return (
    <FooterWrap>
      <div className="flex justify-around items-center w-full footer block lg:hidden fixed bottom-0 left-0 right-0 bg-[#030712] font-lato">

        <Link to="/bookCabs" className="flex flex-col items-center justify-center flex-1 min-w-0 px-1">
          <FaCarSide className="h-6 w-6 text-yellow-400 flex-shrink-0" />
          <span className="text-xs text-white truncate">Cabs</span>
        </Link>

        <Link to="/hotels" className="flex flex-col items-center justify-center flex-1 min-w-0 px-1">
          <FaBuilding className="h-6 w-6 text-indigo-400 mt-1 flex-shrink-0" />
          <span className="text-xs text-white truncate">Stays</span>
        </Link>

        <Link to="/" className="flex flex-col items-center justify-center flex-1 min-w-0 px-1 mb-5">
          <img className="w-10 h-10 bg-white p-1 rounded-full shadow-xl border border-[#030712]" src={TGH} alt="Home" />
          <span className="text-xs text-white truncate">Home</span>
        </Link>

        <Link to="/packages" className="relative flex flex-col items-center justify-center flex-1 min-w-0 px-1">
          <MdTravelExplore className="h-6 w-6 text-blue-500 mt-1 flex-shrink-0" />
          <span className="text-xs text-white truncate">Packages</span>
        </Link>

        <Link to="/wellness" className="flex flex-col items-center justify-center flex-1 min-w-0 px-1">
          <TbLeaf className="h-6 w-6 text-green-600 mt-1 flex-shrink-0" />
          <span className="text-xs text-white truncate">Retreats</span>
        </Link>
      </div>
    </FooterWrap>
  );
}
// const FooterWrap = styled.div`
//   .footer {
//     width: 100%;
//     height: 3.0rem;
//     position: fixed;
//     bottom: 0%;
//     left: 0%;
//     margin-Top: 0px;
//     z-index: 40;
//   }

//   .dropdown:hover .dropdown-menu {
//     display: block;
//   }

//   .navbtn {
//     li {
//       list-style: none;
//       height: 2px;
//       background-color: grey;
//       margin: 4px 0;
//     }
//   }

//   .badge,
//   .notification {
//     position: absolute;
//     z-index: auto;
//     min-width: 15px;
//     height: 15px;
//     padding: 0 3px;
//     color: #f9f9f9;
//     font-size: 10px;
//     line-height: 16px;
//     white-space: nowrap;
//     text-align: center;
//     background: #ff4d4f;
//     font-weight: bold;
//     border-radius: 10px;
//     -webkit-box-shadow: 0 0 0 1px #fff;
//     box-shadow: 0 0 0 1px #fff;
//   }

//   .badge {
//     transform: translate(14px, -28px);
//   }

//   .notification {
//     transform: translate(11px, -26px);
//   }
// `;
const FooterWrap = styled.div`
  .footer {
    width: 100%;
    height: 3.0rem;
    position: fixed;
    bottom: 0%;
    left: 0%;
    margin-top: 0px;
    z-index: 40;
   
  }

  .dropdown:hover .dropdown-menu {
    display: block;
  }

  .navbtn {
    li {
      list-style: none;
      height: 2px;
      background-color: grey;
      margin: 4px 0;
    }
  }

  .badge,
  .notification {
    position: absolute;
    z-index: auto;
    min-width: 15px;
    height: 15px;
    padding: 0 3px;
    color: #f9f9f9;
    font-size: 10px;
    line-height: 16px;
    white-space: nowrap;
    text-align: center;
    background: #ff4d4f;
    font-weight: bold;
    border-radius: 10px;
    -webkit-box-shadow: 0 0 0 1px #fff;
    box-shadow: 0 0 0 1px #fff;
  }

  .badge {
    transform: translate(14px, -28px);
  }

  .notification {
    transform: translate(11px, -26px);
  }
`;

export default Footer;